import * as React from 'react';

import { EPageKind } from '../../../types/page';
import { ICard, ECardType } from '../GlamorousCards/types';
import { HorizontalFullImageCard } from './HorizontalFullImageCard';
import { HorizontalHalfImageCard } from './HorizontalHalfImageCard';
import { VerticalFullImageCard } from './VerticalFullImageCard';
import { VerticalHalfImageCard } from './VerticalHalfImageCard';

interface IProps extends ICard {
  pageKind: EPageKind;
  type: ECardType;
  className?: string;
}

export const GlamorousCard = ({ type, ...props }: IProps) => {
  switch (type) {
    case ECardType.HorizontalFullImage:
      return <HorizontalFullImageCard {...props} />;

    case ECardType.HorizontalHalfImage:
      return <HorizontalHalfImageCard {...props} />;

    case ECardType.VerticalFullImage:
      return <VerticalFullImageCard {...props} />;

    case ECardType.VerticalHalfImage:
      return <VerticalHalfImageCard {...props} />;

    default:
      return null;
  }
};
